import { Record } from "immutable";
import { EvaluationExemptionGrant } from "models/interfaces/enrollments/evaluation-exemption-grant";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: EvaluationExemptionGrant = {
    evaluationExemptionGranted: false,
    evaluationExemptionNotes: undefined
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class EvaluationExemptionGrantRecord extends Record(defaultValues) implements EvaluationExemptionGrant {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<EvaluationExemptionGrant>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    public with(values: Partial<EvaluationExemptionGrant>): EvaluationExemptionGrantRecord {
        return new EvaluationExemptionGrantRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { EvaluationExemptionGrantRecord };

// #endregion Exports
